import makeApiRequest from "./makeApiCall";

export const getNotificationList = async (data, id) => {
  return await makeApiRequest(`/notification/` + id, "GET", null, data);
};
